import React, { useEffect, useState } from 'react';
import { Trash2, MessageSquare } from 'lucide-react';
import { drDanApi } from './drDanApi';

const when = (iso) => new Date(iso).toLocaleString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export const DrDanHistory = ({ onOpen, activeId, onDeleted }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { drDanApi.sessions().then((d) => setRows(d.sessions)).catch(() => setRows([])); }, []);
  const remove = async (e, id) => {
    e.stopPropagation();
    await drDanApi.remove(id);
    setRows((r) => r.filter((x) => x.id !== id));
    onDeleted?.(id);
  };
  if (!rows) return <p className="p-6 text-sm text-slate-400">Loading conversations…</p>;
  if (!rows.length) return <p className="p-6 text-sm text-slate-500" data-testid="dr-dan-history-empty">No saved conversations yet.</p>;
  return (
    <ul className="divide-y" data-testid="dr-dan-history">
      {rows.map((s) => (
        <li key={s.id}>
          <button type="button" onClick={() => onOpen(s.id)} data-testid={`dr-dan-history-item-${s.id}`}
            className={`w-full text-left px-4 py-3 flex items-start gap-3 hover:bg-sky-50 transition-colors ${s.id === activeId ? 'bg-sky-50' : ''}`}>
            <MessageSquare className="w-4 h-4 text-sky-600 mt-0.5 shrink-0" />
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-medium text-slate-800 truncate">{s.title}</span>
              <span className="block text-xs text-slate-400">{when(s.updatedAt)} ET</span>
            </span>
            <span role="button" tabIndex={0} onClick={(e) => remove(e, s.id)} data-testid={`dr-dan-history-delete-${s.id}`}
              className="p-1 rounded text-slate-400 hover:text-rose-600 hover:bg-rose-50" title="Delete conversation">
              <Trash2 className="w-4 h-4" />
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};
